module.exports = __webpack_public_path__ + "img/pc_banner.10d90ba6.jpg";